export default {
  "token": {
    "colorPrimary": "#F46459",
    "colorPrimaryBgHover": "#F46459",
    "colorPrimaryBg": "#F46459",
    "colorPrimaryTextActive": "#FFF"
  }
}